"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsClassName = void 0;
const getColumnsClassName = (numberColumns) => {
    switch (numberColumns) {
        case 1:
            return "input-col-sm-12";
        case 2:
            return "input-col-sm-6";
        case 3:
            return "input-col-sm-4";
        default:
            return "";
    }
};
exports.getColumnsClassName = getColumnsClassName;
//# sourceMappingURL=helpers.js.map